/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../store/useAuth";
import axios from "axios";
import { useEffect, useMemo } from "react";
import { useAlert } from "../store/useAlert";
import { AppLoading } from "../components/indicators/AppLoading";
import { SummaryLoading } from "../components";

const LocalProvider = ({ children }: { children: JSX.Element }) => {
  /** Hooks */
  const { accessToken } = useAuth();
  const { alert, setAlert } = useAlert();

  useEffect(() => {
    if (accessToken) {
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      axios.defaults.headers.common.Authorization = "";
    }
  }, [accessToken]);

  useEffect(() => {
    if (alert?.isOpen) {
      setTimeout(() => {
        setAlert({ isOpen: false, message: "", severity: "info" });
      }, 5000);
    }
  }, [alert?.isOpen]);

  const alertColor = useMemo(() => {
    if (alert?.severity === "error") {
      return "bg-red-50 dark:bg-red-800 text-red-800 dark:text-red-400";
    }
    if (alert?.severity === "warning") {
      return "bg-yellow-50 dark:bg-yellow-800 text-yellow-800 dark:text-yellow-400";
    }
    if (alert?.severity === "info") {
      return "bg-blue-50 dark:bg-blue-800 text-blue-800 dark:text-blue-400";
    }
    if (alert?.severity === "success") {
      return "bg-green-50 dark:bg-green-800 text-green-800 dark:text-green-400";
    }
    return "bg-blue-50 dark:bg-blue-800 text-blue-800 dark:text-blue-400";
  }, [alert?.severity]);

  return (
    <>
      {children}
      {alert?.isOpen ? (
        <div
          // Above every modal: the edit modals render at z-[10000000000], and
          // an alert fired from inside one (e.g. a failed save) must not end
          // up hidden behind the very dialog that triggered it.
          className={`fixed top-[100px] right-4 p-4 mb-4 text-sm rounded-lg z-[10000000001] ${alertColor} transition ease-linear`}
        >
          <span className="font-medium">{alert?.message}</span>
        </div>
      ) : null}
      <AppLoading />
      <SummaryLoading />
    </>
  );
};

export default LocalProvider;
